// extracted by css-extract-rspack-plugin
export default {"cardViewArea":"cardViewArea-Il3VD_"};